var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _path, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _path2, _rect18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 187 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.520526,
    y: 96.1094,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -0.520526,
    y: 0.520526,
    width: 27.9309,
    height: 28.37,
    transform: "matrix(-1 0 0 1 185.959 95.5889)",
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 95.3375,
    y: 96.1094,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 123.315,
    y: 92.6172,
    width: 27.9309,
    height: 28.37,
    transform: "rotate(-180 123.315 92.6172)",
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 110.088,
    y: 92.5859,
    width: 14.75,
    height: 28.3214,
    transform: "rotate(-180 110.088 92.5859)",
    fill: "#121212",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 95.3375,
    y: 32.3848,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M109.972 15.3896L109.98 15.3819L109.988 15.3739L123.268 1.30942V28.8905H96.0983L109.972 15.3896Z",
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1254,
    y: 96.1094,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1254,
    y: 64.2471,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1254,
    y: 32.3848,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 32.1254,
    y: 0.520526,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 126.943,
    y: 96.1094,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 126.943,
    y: 64.2471,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 126.943,
    y: 32.3848,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 126.943,
    y: 0.520526,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 63.7326,
    y: 96.1094,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 91.7329,
    y: 92.6172,
    width: 27.9309,
    height: 28.37,
    transform: "rotate(-180 91.7329 92.6172)",
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 63.7326,
    y: 32.3848,
    width: 27.9309,
    height: 28.37,
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0433 15.3739L90.9046 28.8905H63.7326V1.30744L77.0286 15.359L77.0358 15.3666L77.0433 15.3739Z",
    fill: "white",
    stroke: "#121212",
    strokeWidth: 1.04105
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 78.4826,
    y: 92.5859,
    width: 14.7501,
    height: 28.3214,
    transform: "rotate(-180 78.4826 92.5859)",
    fill: "#121212",
    stroke: "#121212",
    strokeWidth: 1.04105
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLeft);
export default __webpack_public_path__ + "static/media/logo-left.5a81d749f7e0e74f50e19cb2c1a9712d.svg";
export { ForwardRef as ReactComponent };